import actions from "./actions"

const updateIntl = (lang) => (actions.updateIntl(lang))

export default {
    updateIntl
}